export default __webpack_public_path__ + "static/media/java.5e17633c.svg";